import { useCallback, useEffect, useState } from 'react';
import {
  fetchReservationSweepHistory,
  type ReservationSweepRun,
} from '@/services/inventory';

// Carga el histórico de las últimas corridas del barrido de reservas
// (automáticas y manuales), con su estado éxito/error y cuántos pedidos liberó.
export function useReservationSweepHistory(limit = 12) {
  const [runs, setRuns] = useState<ReservationSweepRun[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    let cancelled = false;
    setLoading(true);
    fetchReservationSweepHistory(limit)
      .then((res) => {
        if (!cancelled) setRuns(res);
      })
      .catch(() => {
        if (!cancelled) setRuns([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [limit]);

  useEffect(() => load(), [load]);

  return { runs, loading, refetch: load };
}